<template>
  <div>
    <div class="contents">
      <BaseHeader title="バッチ一覧" />
    </div>
  </div>
</template>

<script>
import BaseHeader from '@/components/molecules/BaseHeader'

export default {
  name: 'Batch',
  components: {
    BaseHeader
  },
  created () {
  }
}
</script>
